/* eslint-disable react/jsx-key */
import React, { useEffect, useState } from "react"
import { StyleSheet, Document, Page, Text, View, PDFDownloadLink, Font } from '@react-pdf/renderer';
import { buildLanguages, getAboveTitleItems } from '../../../services/pdfGeneratorService';
import BentzDesign from "./Components/BentzDesign";
import HopperDesign from "./Components/HopperDesign";
import LamarrDesign from "./Components/LamarrDesign";
import NickDesign from "./Components/NickDesign";
import { getColorInfo } from "../../../pages/ResumeBuilder/Components/DesignStep/constants";
import { registerPdfFonts } from "./service";

function parseHtmlToText(html, textStyle = {}) {
    if (!html) return '';
    
    // First, strip all HTML tags except <p> tags
    const cleanHtml = html.replace(/<(?!\/?p[^>]*>)[^>]+>/g, '');
    
    // Split by <p> tags
    const parts = cleanHtml.split(/<\/?p[^>]*>/g);
    
    // Filter out empty parts and create Text components
    const textComponents = parts
        .map(part => part.trim())
        .filter(part => part.length > 0)
        .map((part, index) => (
            <Text key={index} style={textStyle}>
                {part}
            </Text>
        ));
    
    return textComponents;
}

export const ResumePrint = (props = {}) => {
    const { resume } = props;
    const selectedFont = resume?.design?.font || 'verdana';
    useEffect(() => {
        registerPdfFonts();
    }, []);

    // Get font family based on selected font - use built-in PDF fonts
    const getFontFamily = (font) => {
        switch (font) {
            case 'georgia':
                return 'Georgia'; // Now uses the registered Georgia font
            case 'garamond':
                return 'EBGaramond'; // Now uses the registered EB Garamond font
            case 'verdana':
                return 'Verdana'; // Now uses the registered Verdana font
            default:
                return 'Verdana'; // Built-in sans-serif font
        }
    };
    const getDateOfBirth = (dateOfBirth) => {
        if (!dateOfBirth) return null;
        const date = new Date(dateOfBirth);
        return date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        });
    };
 
    const getPageStyle = (templateStyle) => {
        switch (templateStyle) {
            case 'lamarr':
                return {
                    width: '100%',
                    padding: 0,
                    margin: 0,
                    fontFamily: getFontFamily(selectedFont),
                };
            case 'bentz':
                return {
                    width: '100%',
                    padding: 20,
                    margin: 0,
                    fontFamily: getFontFamily(selectedFont),
                }
            case 'hopper':
            default:
                return {
                    width: '100%',
                    padding: 20,
                    fontFamily: getFontFamily(selectedFont),
                };
        }
    };

    const aboveTitleItems = getAboveTitleItems(resume);
    const shouldShowHeader = resume.firstName || resume.lastName || resume.title;
    const shouldShowExperience = resume.experience?.some(e => e.companyName || e.jobPosition);
    const shouldShowEducation = resume.education?.some(e => e.universityName || e.degreeName || e.courseName);
    const shouldShowSkills = resume.skills?.length > 0;
    const languagesAsText = buildLanguages(resume);
    const style = resume.design?.style || 'bentz';
    const color = resume.design?.color || 'black';
    const layout = resume.design?.layout || 'centered';
    const selectedColor = getColorInfo(color);
    const pageStyle = getPageStyle(style);
    if (selectedColor?.backgroundColor && !['lamarr'].includes(style)) {
        pageStyle.backgroundColor = selectedColor?.backgroundColor;
    }
    if (!resume) return null;
    const sharedProps = {
        backgroundColor: selectedColor?.backgroundColor,
        textColor: selectedColor?.textColor,
        getFontFamily,
        shouldShowHeader,
        aboveTitleItems,
        data: resume,
        selectedFont,
        parseHtmlToText,
        shouldShowExperience,
        shouldShowEducation,
        shouldShowSkills,
        languagesAsText,
        layout,
        dateOfBirth: getDateOfBirth(resume.dateOfBirth)
    }
    return (
        <>
            <Document showToolbar={false} >
                <Page size="A4" style={pageStyle} 
                  renderAnnotationLayer={false} 
                  renderTextLayer={false}
                  
                showToolbar={false}>
                    {style === 'bentz' && <BentzDesign {...sharedProps} />}
                    {style === 'hopper' && <HopperDesign {...sharedProps} />}
                    {style === 'lamarr' && <LamarrDesign {...sharedProps} />}
                    {style === 'nick' && <NickDesign {...sharedProps} />}
                </Page>
            </Document>
        </>
    )
}

const Wrapper = (props) => {
    const [init, setInit] = useState(false)
    useEffect(() => {
        // setTimeout(() => {
        setInit(true)
        // }, 4000)
    }, [])
    if (!init) {
        return <div>Loading...</div>
    }
    return (
        <div>
            <PDFDownloadLink document={<ResumePrint resume={props.resume} />} fileName="somename.pdf">
                {({ blob, url, loading, error }) => (loading ? 'Loading document...' : 'Download now!')}
            </PDFDownloadLink>
            <br /><br />
            <br />
            <ResumePrint resume={props.resume} />
        </div>
    )
}

export default Wrapper
